import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { TitleFeesThatGoInSectionH } from '../../../ui-toolkit/enums/TitleFeesThatGoInSectionH';
import { eUnderwriter } from '../../../ui-toolkit/enums/eUnderwriter';
import { eSalesTaxSubTypes } from '../../../ui-toolkit/enums/eSalesTaxSubTypes';

const salesTaxSubTypesInSectionBOrC = [
  eSalesTaxSubTypes.title_fee_lenders,
  eSalesTaxSubTypes.title_fee_extended_lenders_policy,
];

export default function computeShowMovable(item: ICDV3ViewItem, underwriter?: eUnderwriter) {
  return (
    (item.type === eCDV3ItemTypes.title_fee &&
      (!item.sub_type || !TitleFeesThatGoInSectionH.includes(item.sub_type))) ||
    item.type === eCDV3ItemTypes.title_fee_other ||
    item.type === eCDV3ItemTypes.endorsement ||
    item.type === eCDV3ItemTypes.endorsement_other ||
    item.type === eCDV3ItemTypes.other_loan_cost ||
    (item.type === eCDV3ItemTypes.sales_tax && item.sub_type && salesTaxSubTypesInSectionBOrC.includes(item.sub_type))
  );
}
